import FourOFour from 'pages/404/404.vue';

export default [
    {
        name: 'fourOFour',
        path: '/*',
        component: FourOFour,
    },
];


// WEBPACK FOOTER //
// ./src/pages/404/routes.js